import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/material/form-field';
import { WorkOrderService } from '@app/services/work-order.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'formly-field-button',
  template: `
    <div>
      <button [type]="to.type" [ngClass]="'btn btn-' + to.btnType" (click)="onClick($event,to.url)">
        {{ to.text }}
      </button>
      <button [type]="to.type" [ngClass]="'btn btn-' + to.btnType" (click)="onRemove($event,to.id)"
        style="float: right;">
        <i class="material-icons left">delete</i>
      </button>
      <button [type]="to.type" [ngClass]="'btn btn-' + to.btnType" (click)="onPreview($event,to.url)"
        style="float: right;">
        <i class="material-icons left">visibility</i>
      </button>
    </div>
  `
})
export class FormlyFieldButton extends FieldType {

  constructor(private workOrderService: WorkOrderService) {
    super();
  }

  onRemove($event: any, id: string) {
    console.log('llego al delete custom con id ' + id);
    return this.workOrderService.eliminarOrdenDeTrabajoArchivo(id).subscribe(response => {
      console.log('Archivo eliminado');
      window.location.reload();
    }), (error: any) => {
      console.log('No se pudo eliminar el archivo');
    }, () => console.info('Archivo eliminado correctamente');
  }

  onPreview($event: any, url: string) {
    window.open(this.workOrderService.getDownloadURL(url));
  }

  onClick($event: any, url: string) {
    return this.workOrderService.download(url).subscribe(response => {
      console.log('Descargando el archivo');
      const fileName: string = url.substr(url.lastIndexOf('/') + 1, url.length);
      const file = new File([response], fileName, { type: response.type });
      saveAs(file);
    }), (error: any) => {
      console.log('No se pudo descargar el archivo');
    },
    () => console.info('Archivo descargado correctamente');
  }
}
